import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../BusinessObjects/Redux/app/store";
import { useFiltersObjEdit } from "./FiltersOnFields";
import { useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";
import RenderFormNew from "../../../Components/Esaedro/RenderForm/RenderFormNew";
import { RoutePath } from "../../../Utils/RoutePath";
import { Form } from "../../../Models/SysConf/Form";
import { useQuery } from "react-query";
import { ResourceNames } from "../../../Utils/ResourceNames";
import cubeApiClient from "../../../BusinessObjects/cubeApiService";
import notify from "devextreme/ui/notify";

type Props = {};

const FiltersOnFieldsEdit = (props: Props) => {
  // Redux
  const tokenApi = useSelector((state: RootState) => state.user.tokenAPI);
  const userProfile = useSelector((state: RootState) => state.user.userProfile);
  const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);

  // React Router Dom
  const { objEdit, setObjEdit } = useFiltersObjEdit();
  const navigate = useNavigate();

  // Chiamate Api
  const {
    data: resourcesViewsFilters,
    isLoading: isLoadingResourcesViewsFilters,
    isError: isErrorResourcesViewsFilters,
    refetch: refetchResourcesViewsFilters,
    isRefetching: isRefetchingResourcesViewsFilters,
  } = useQuery(
    ["resourcesViewsFilters", objEdit?.View_ID, tokenApi],
    () => {
      var urlToUse = `api/sys/${ResourceNames.ResourcesViewsFilters}?RecordSelection=View_ID=${objEdit?.View_ID}`;
      const service = new cubeApiClient();

      return service.getItems(urlToUse, tokenApi);
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const {
    data: formResourcesViewsFilters,
    isLoading: isLoadingFormResourcesViewsFilters,
  } = useQuery(
    [
      "form",
      ResourceNames.ResourcesViewsFilters,
      userProfile?.customer_ID,
      tokenApi,
    ],
    () => {
      const service = new cubeApiClient();

      return service
        .getItems(
          `api/sys/${ResourceNames.Resources}?RecordSelection=ResourceName='${ResourceNames.ResourcesViewsFilters}'`,
          tokenApi
        )
        .then(
          (data: any) => {
            let urlForm = `api/sys/${ResourceNames.Forms}/query?ResourceId=${data[0].Resource_ID}`;

            return service.getItems(urlForm, tokenApi).then(
              (data: any) => {
                return data[0];
              },
              (error: any) => {
                return undefined;
              }
            );
          },
          (error: any) => {
            return undefined;
          }
        );
    },
    {
      enabled: isLoggedIn,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const formResourceViewFilter: Form | undefined = React.useMemo(() => {
    if (formResourcesViewsFilters) {
      let tmpForm: Form = formResourcesViewsFilters;

      tmpForm.FormsGroups.forEach((fg) => {
        fg.FormsFields.forEach((ff) => {
          if (ff.FieldName === "View_ID") {
            ff.Is_Editable = false;
          }
        });
      });

      return tmpForm;
    }

    return undefined;
  }, [formResourcesViewsFilters]);

  // Salvo il nuovo filtro
  const saveNewResourceViewFilter = () => {
    const service = new cubeApiClient();

    service
      .updateObject(
        objEdit,
        `api/sys/${ResourceNames.ResourcesViewsFilters}`,
        tokenApi
      )
      .then(
        (data) => {
          refetchResourcesViewsFilters();
          navigate(
            `${RoutePath.RESOURCES_VIEWS}/${objEdit?.View_ID}/fiters_on_fields`
          );
          notify("Filtro salvato con successo", "success", 1000);
        },
        (error) => {
          refetchResourcesViewsFilters();
          notify("Errore nel salvataggio del filtro", "error", 1000);
        }
      );
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          justifyContent: "space-around",
          alignItems: "center",
          mt: 1,
          flexDirection: "row",
          mb: 3,
        }}
      >
        <React.Fragment>
          <RenderFormNew
            showTitle={false}
            isNew={false}
            form={formResourceViewFilter}
            myObj={objEdit}
            saveNewObject={(e) => setObjEdit(e)}
          />
        </React.Fragment>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          mt: 1,
          flexDirection: "row",
        }}
      >
        <Button
          variant="contained"
          color="error"
          className="me-2"
          onClick={() =>
            navigate(
              `${RoutePath.RESOURCES_VIEWS}/${objEdit?.View_ID}/fiters_on_fields`
            )
          }
        >
          Annulla
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={() => saveNewResourceViewFilter()}
        >
          Salva
        </Button>
      </Box>
    </>
  );
};

export default FiltersOnFieldsEdit;
